import uuid from 'uuid';

import requirementsParser from './requirementsParser';
import CKEditorLoader from './libraries/CKEDitor';
import MomentTimezone from './libraries/MomentTimezone';

const generalResourcesCacher = {
    getAllQuestions(assessment) {
        return assessment.sections.reduce((questionsArr, section) => {
            return questionsArr.concat(section.questions);
        }, []);
    },

    async cacheFiles(files, title, filePackageCacher) {
        return filePackageCacher({
            files,
            title,
            id: uuid.v4(),
            type: 'general',
        });
    },

    async cacheAll(assessment, filePackageCacher) {
        const questions = this.getAllQuestions(assessment);
        const promisedDependencies = [];

        promisedDependencies.push(MomentTimezone.getAllFilesToCache());

        /* HANDLED BY PRE-RENDERING
        if (requirementsParser.isAceEditorRequired(questions)) {
            const filesToCache = ACEEditorLoader.getAllFilesToCache(questions);
            promisedDependencies.push(
                generalResourcesCacher.cacheFiles(filesToCache, 'ACE Editor resources', filePackageCacher),
            );
        }

        if (requirementsParser.isMathJaxRequired(questions)) {
            const filesToCache = MathJaxLoader.getAllFilesToCache();
            promisedDependencies.push(
                generalResourcesCacher.cacheFiles(filesToCache, 'MathJax resources', filePackageCacher),
            );
        }

        // No point running this if cacheHandler === sw. All PDFJS files get requested by an html file on aws.
        if (requirementsParser.isPdfJsRequired(questions)) {
            promisedDependencies.push(
                generalResourcesCacher.cacheFiles(PDFJSLoader.getAllFilesToCache(), 'PDFJS resources', filePackageCacher),
            );
        }
        */

        if (requirementsParser.isCkEditorRequired(questions)) {
            promisedDependencies.push(
                generalResourcesCacher.cacheFiles(CKEditorLoader.getAllFilesToCache(), 'CKEditor resources', filePackageCacher),
            );
        }

        try {
            await Promise.all(promisedDependencies);
            window.console.log('GENERAL_RESOURCES_CACHE: OK');
        } catch (error) {
            window.console.log('GENERAL_RESOURCES_CACHE: ERROR');
            window.console.log(error);
        }
    },
};

export default generalResourcesCacher;
